import gql from 'graphql-tag';
import { buildConnectionQuery } from "../../helpers.class";

export const getAgingEmailTemplatesQuery = gql`query getAgingEmailTemplates {
  getAgingEmailTemplates {
    title
    subject
    body
  }
}
`;

export const sendAgingInvoiceNoticeMutation = gql`mutation sendAgingInvoiceNotice($input: AgingNoticeInput!) {
  sendAgingInvoiceNotice(input: $input){
    success
    message
  }
}`;

const sageInvoiceAgingReminderFragment = `
  id
  sageInvoiceId
  customerId
  customerName
  emails
  dateSent
  emailTemplate
  invoiceNumber
  referenceNumber
  totalTxnAmountDue
  status
  CreatedBy {
    id
    firstName
    lastName
  }
  createdAt
  updatedAt
`;

export const SageInvoiceAgingReminderConnectionQuery = gql`${buildConnectionQuery("SageInvoiceAgingReminder", "SageInvoiceAgingReminderConnection", sageInvoiceAgingReminderFragment)}`;
